(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/youtube-playlist/assets/javascripts/youtube-playlist.js') >= 0) return;  svs.modules.push('/widgets/youtube-playlist/assets/javascripts/youtube-playlist.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.youtube_playlist = svs.widget.youtube_playlist || {};
svs.widget.youtube_playlist.init = svs.components.youtube_playlist.init;

 })(window);